// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"7fb7dc6a","205":"d628b8f6","231":"7ceac279","760":"d3ffab8a"}[chunkId] + ".chunk.css";
};